<app-login-dialog (loginEvent)="login($event)" [errorMessage]="errorMessage"></app-login-dialog>
